@if (documents && documents.length > 0) {
  <article class="table {{ appService.documentStatusFilter }}">
    <app-multi-selection-toolbar
      (onClose)="closeSelection()"
      [isOpen]="documents && (documents | filterBy: { _isSelected: true }).length > 0"
      [label]="
        'documents.' + ((documents | filterBy: { _isSelected: true }).length === 1 ? 'selectedDocument' : 'selectedDocuments')
          | translate: { documents: (documents | filterBy: { _isSelected: true }).length }
      "
    >
      @let hasMain = toolbarActiveActions.main.length > 0;
      @let hasInlineSecondary = inlineSecondaryActions.length > 0;
      @let hasDropdownSecondary = dropdownSecondaryActions.length > 0;
      @let hasDanger = toolbarActiveActions.danger.length > 0;
      @let hasInlineDanger = currentViewportType === 'desktop' && hasDanger;
      @let hasDropdownDanger = currentViewportType !== 'desktop' && hasDanger;
      @let hasDropdown = hasDropdownSecondary || hasDropdownDanger;
      @let groupCount = (hasMain ? 1 : 0) + (hasInlineSecondary ? 1 : 0) + (hasInlineDanger ? 1 : 0) + (hasDropdown ? 1 : 0);

      @if (groupCount === 1) {
        <div class="selection-toolbar__divider"></div>
      }

      @for (mainActions of toolbarActiveActions.main; track mainActions.id) {
        <button type="button" class="btn-M btn-text icon-start" (click)="mainActions.action()">
          <i class="{{ mainActions.icon }}"></i>
          {{ mainActions.label | translate }}
        </button>
      }

      @if (hasMain && (hasInlineSecondary || hasDropdown)) {
        <div class="selection-toolbar__divider"></div>
      }

      @for (action of inlineSecondaryActions; track action.id) {
        <button type="button" class="btn-M btn-text icon-start secondary" (click)="action.action()">
          <i [class]="action.icon"></i>
          {{ action.label | translate }}
        </button>
      }

      @if (hasInlineSecondary && hasDropdown) {
        <div class="selection-toolbar__divider"></div>
      }

      @if (hasDropdown) {
        <div appDropdown placement="bottom-right">
          <button type="button" class="btn-M btn-text icon-only secondary" [attr.aria-label]="'documents.options' | translate" appDropdownToggle>
            <i class="far fa-ellipsis-v"></i>
          </button>

          <div appDropdownMenu>
            @for (action of dropdownSecondaryActions; track action.id) {
              <button (click)="action.action()" type="button" appDropdownItem>
                <i [class]="action.icon"></i>
                {{ action.label | translate }}
              </button>
            }

            @if (hasDropdownSecondary && hasDropdownDanger) {
              <hr class="dropdown-divider" />
            }

            @if (hasDropdownDanger) {
              @for (dangerActions of toolbarActiveActions.danger; track dangerActions.id) {
                <button (click)="dangerActions.action()" type="button" class="dropdown__item--danger" appDropdownItem>
                  <i [class]="dangerActions.icon"></i>
                  {{ dangerActions.label | translate }}
                </button>
              }
            }
          </div>
        </div>
      }

      @if (hasInlineDanger) {
        @if (hasInlineSecondary) {
          <div class="selection-toolbar__divider"></div>
        }

        @for (dangerActions of toolbarActiveActions.danger; track dangerActions.id) {
          <button type="button" class="btn-M btn-text btn-text-danger icon-start" (click)="dangerActions.action()">
            <i [class]="dangerActions.icon"></i>
            {{ dangerActions.label | translate }}
          </button>
        }
      }
    </app-multi-selection-toolbar>

    <div class="table__row table__row-titles" [class.d-none]="!documents[0]">
      <div class="table__col table__col-select">
        <app-checkbox class="checkbox" [(ngModel)]="isMainCheckboxChecked" (change)="onChangeMainCheckbox(isMainCheckboxChecked)" *ngIf="isAllowedToSomething()" #mainCheckbox></app-checkbox>
      </div>
      <div class="content">
        <div class="table__col table__col-name table__col-sortable" (click)="changeSorting(ListSorting.Name)">
          {{ 'documents.name' | translate }}
          @if (appService.listSorting === ListSorting.Name) {
            @if (appService.listDirection === OrderByEnum.Desc) {
              <i class="fa-solid fa-chevron-down table__sort-icon"></i>
            }
            @if (appService.listDirection === OrderByEnum.Asc) {
              <i class="fa-solid fa-chevron-up table__sort-icon"></i>
            }
          } @else {
            <i class="fa-solid fa-angles-up-down table__sort-icon"></i>
          }
          <div
            class="resize"
            (mousemove)="resizeWidth($event)"
            (mouseup)="resizePressedUp(false, $event)"
            (mouseleave)="resizePressedUp(false, $event)"
            (mousedown)="resizePressedDown(true, $event, 'table__col table__col-name')"
          ></div>
        </div>
        <div class="table__col table__col-status" *ngIf="appService.documentsListColumns.includes(DocumentsListColumns.Status)">
          {{ 'documents.status' | translate }}
          <div
            class="resize"
            (mousemove)="resizeWidth($event)"
            (mouseup)="resizePressedUp(false, $event)"
            (mouseleave)="resizePressedUp(false, $event)"
            (mousedown)="resizePressedDown(true, $event, 'table__col table__col-status')"
          ></div>
        </div>
        <div class="table__col table__col-signers" *ngIf="appService.documentsListColumns.includes(DocumentsListColumns.Signers)">
          {{ 'documents.signatories' | translate }}
          <div
            class="resize"
            (mousemove)="resizeWidth($event)"
            (mouseup)="resizePressedUp(false, $event)"
            (mouseleave)="resizePressedUp(false, $event)"
            (mousedown)="resizePressedDown(true, $event, 'table__col table__col-signers')"
          ></div>
        </div>
        <div
          class="table__col table__col-date created table__col-sortable"
          *ngIf="appService.documentsListColumns.includes(DocumentsListColumns.CreatedAt)"
          (click)="changeSorting(ListSorting.CreatedAt)"
        >
          {{ 'documents.createdIn' | translate }}
          @if (appService.listSorting === ListSorting.CreatedAt) {
            @if (appService.listDirection === OrderByEnum.Desc) {
              <i class="fa-solid fa-chevron-down table__sort-icon"></i>
            } @else if (appService.listDirection === OrderByEnum.Asc) {
              <i class="fa-solid fa-chevron-up table__sort-icon"></i>
            }
          } @else {
            <i class="fa-solid fa-angles-up-down table__sort-icon"></i>
          }
          <div
            class="resize"
            (mousemove)="resizeWidth($event)"
            (mouseup)="resizePressedUp(false, $event)"
            (mouseleave)="resizePressedUp(false, $event)"
            (mousedown)="resizePressedDown(true, $event, 'table__col table__col-date created')"
          ></div>
        </div>
        <div
          class="table__col table__col-date updated table__col-sortable"
          *ngIf="appService.documentsListColumns.includes(DocumentsListColumns.UpdatedAt)"
          (click)="changeSorting(ListSorting.UpdatedAt)"
        >
          {{ 'documents.modifiedOn' | translate }}
          @if (appService.listSorting === ListSorting.UpdatedAt) {
            @if (appService.listDirection === OrderByEnum.Desc) {
              <i class="fa-solid fa-chevron-down table__sort-icon"></i>
            } @else if (appService.listDirection === OrderByEnum.Asc) {
              <i class="fa-solid fa-chevron-up table__sort-icon"></i>
            }
          } @else {
            <i class="fa-solid fa-angles-up-down table__sort-icon"></i>
          }
          <div
            class="resize"
            (mousemove)="resizeWidth($event)"
            (mouseup)="resizePressedUp(false, $event)"
            (mouseleave)="resizePressedUp(false, $event)"
            (mousedown)="resizePressedDown(true, $event, 'table__col table__col-date updated')"
          ></div>
        </div>
      </div>
      <div class="columns-dropdown" display="dynamic" placement="bottom-right" appDropdown>
        <label appDropdownToggle><i class="fal fa-columns"></i></label>
        <div appDropdownMenu>
          <button type="button" class="dropdown__item-checkbox" disabled>
            <label>
              <app-checkbox [value]="true" disabled></app-checkbox>&nbsp;
              {{ 'documents.documentName' | translate }}
            </label>
          </button>
          <button type="button" class="dropdown__item-checkbox">
            <label>
              <app-checkbox (change)="toggleColumn(DocumentsListColumns.Status)" [value]="appService.documentsListColumns.includes(DocumentsListColumns.Status)"></app-checkbox>&nbsp;
              {{ 'documents.status' | translate }}
            </label>
          </button>
          <button type="button" class="dropdown__item-checkbox">
            <label>
              <app-checkbox (change)="toggleColumn(DocumentsListColumns.Signers)" [value]="appService.documentsListColumns.includes(DocumentsListColumns.Signers)"></app-checkbox>&nbsp;
              {{ 'documents.signatories' | translate }}
            </label>
          </button>
          <button type="button" class="dropdown__item-checkbox">
            <label>
              <app-checkbox (change)="toggleColumn(DocumentsListColumns.CreatedAt)" [value]="appService.documentsListColumns.includes(DocumentsListColumns.CreatedAt)"></app-checkbox>&nbsp;
              {{ 'documents.creationDate' | translate }}
            </label>
          </button>
          <button type="button" class="dropdown__item-checkbox">
            <label>
              <app-checkbox (change)="toggleColumn(DocumentsListColumns.UpdatedAt)" [value]="appService.documentsListColumns.includes(DocumentsListColumns.UpdatedAt)"></app-checkbox>&nbsp;
              {{ 'documents.lastModification' | translate }}
            </label>
          </button>
        </div>
      </div>
    </div>
    <div *ngFor="let document of documents" class="table__row table__row-document {{ document ? documentsListingService.documentStatusClasses(document).join(' ') : 'loading' }}">
      <div class="table__col table__col-select" *ngIf="document">
        <app-checkbox class="checkbox" [(ngModel)]="document._isSelected" (change)="onChangeCheckbox('document')"></app-checkbox>
      </div>
      <a [routerLink]="document ? ['/documentos/', document.id] : []" class="link">
        <div class="table__col table__col-name">
          <ng-container *ngIf="document">
            <div class="document-label deadline" *ngIf="documentService.isPastDeadline(document); else bottomDeleted" [ngbTooltip]="deadlineTooltip" placement="right" container="body">
              <i class="far fa-lock"></i>
              <ng-template #deadlineTooltip>
                <div class="tooltip__title">{{ 'documents.documentBlocked' | translate }}</div>
                <div class="tooltip__descr">{{ 'documents.documentBlockedDate' | translate: { date: document?.deadline_at | dateTime } }}</div>
              </ng-template>
            </div>
            <ng-template #bottomDeleted>
              <div
                class="document-label deleted"
                *ngIf="currentOrganizationMemberId && listingService.deletedByUserAt(document, currentOrganizationMemberId); else bottomLifecycle"
                [ngbTooltip]="deletedTooltip"
                placement="right"
                container="body"
              >
                <i class="far fa-trash"></i>
                <ng-template #deletedTooltip>
                  <div class="tooltip__title">{{ 'documents.deletedDocument' | translate }}</div>
                  <div class="tooltip__descr">
                    {{ 'documents.deletedDocumentMessage' | translate: { date: listingService.deletedByUserAt(document, currentOrganizationMemberId) | ldate } }}
                  </div>
                </ng-template>
              </div>
            </ng-template>
            <ng-template #bottomLifecycle>
              <div class="document-label lifecycle" *ngIf="documentService.isPastLifecycle(document); else bottomSandbox" [ngbTooltip]="lifecycleTooltip" placement="right" container="body">
                <i class="far fa-boxes-alt"></i>
                <ng-template #lifecycleTooltip>
                  <div class="tooltip__title">{{ 'documents.lifecycleExpired' | translate }}</div>
                  <div class="tooltip__descr">{{ 'documents.lifecycleExpiredMessage' | translate: { date: document.lifecycle_in | ldate } }}</div>
                </ng-template>
              </div>
            </ng-template>
            <ng-template #bottomSandbox>
              <div class="document-label sandbox" *ngIf="document?.sandbox" [ngbTooltip]="sandboxTooltip" placement="right" container="body"><i class="far fa-vial"></i></div>
            </ng-template>
          </ng-container>
          <span [ngClass]="{ active: document?._isSelected }">{{ document?.name || '' }}&nbsp;</span>
        </div>
        <div class="table__col table__col-status" *ngIf="appService.documentsListColumns.includes(DocumentsListColumns.Status)">
          <span *ngIf="document && documentService.isSigned(document) && !documentService.isExpired(document)">
            {{ 'documents.' + (document.is_dynamic_document ? 'filledAndSigned' : 'signed') | translate }}
          </span>
          <span
            *ngIf="document && documentService.isPending(document) && !documentService.isExpired(document)"
            [innerHTML]="
              'documents.pending'
                | translate
                  : {
                      pendingSigners: ({ signers: document.signatures } | filterPendingSigners).length,
                      totalSigners: ({ signers: document.signatures } | filterSigners).length
                    }
            "
          >
          </span>
          <span *ngIf="document && documentService.isExpired(document)">
            {{ 'documents.expired' | translate }}
          </span>
          <span *ngIf="document && documentService.isRejected(document)">
            {{ 'documents.rejected' | translate }}
          </span>
        </div>
        <div class="table__col table__col-signers" *ngIf="appService.documentsListColumns.includes(DocumentsListColumns.Signers)">
          <ng-container *ngFor="let signer of document ? ({ signers: document.signatures } | filterSigners | slice: 0 : maxSigners) : [].constructor(2)">
            <div
              *ngIf="!signer || returnSignerIdentifier(signer)"
              class="table__signer"
              [ngClass]="{ signed: documentService.isSignerSigned(signer), rejected: documentService.isSignerRejected(signer), unapproved: documentService.isSignerUnapproved(signer) }"
            >
              {{ signer ? returnSignerIdentifier(signer) : '' }}&nbsp;
            </div>
          </ng-container>
        </div>
        <div class="table__col table__col-date created" *ngIf="appService.documentsListColumns.includes(DocumentsListColumns.CreatedAt)">
          <span class="table__col-date-text">{{ document?.created_at | ldate: 'mediumDate' }}&nbsp;</span>
        </div>
        <div class="table__col table__col-date updated" *ngIf="appService.documentsListColumns.includes(DocumentsListColumns.UpdatedAt)">
          <span class="table__col-date-text">{{ document?.updated_at | ldate: 'mediumDate' }}&nbsp;</span>
        </div>
      </a>
      @if (document) {
        <div class="table__col-dropdown" appDropdown placement="bottom-right">
          <button type="button" class="dropdown__toggle-control dropdown__toggle-control--icon-only" appDropdownToggle>
            <i class="fa-regular fa-ellipsis-v dropdown__toggle-icon--font-size-16"></i>
          </button>
          <div appDropdownMenu>
            @if (!documentsListingService.isCurrentUserSignerPending(document)) {
              <button type="button" appDropdownItem [routerLink]="['/documentos/', document.id]"><i class="fa-regular fa-eye"></i> {{ 'button.view' | translate }}</button>
            }
            @if (!isTrash) {
              @if (!documentsListingService.deletedByUserAt(document, currentUser.id)) {
                @if (documentsListingService.hasCurrentUser(document) && documentsListingService.isAllowedToSign(document) && !document.is_dynamic_document) {
                  <button type="button" appDropdownItem (click)="signClick.emit([document])"><i class="fa-regular fa-feather-alt"></i> {{ 'button.sign' | translate }}</button>
                }
                <button
                  type="button"
                  appDropdownItem
                  [submenuToggle]="'table-submenu1-' + document.id"
                  [attr.aria-labelledby]="'table-submenu1-' + document.id"
                  [disabled]="isLoading || documentService.isPastLifecycle(document)"
                >
                  <i class="fa-regular fa-cloud-download-alt"></i> {{ 'button.download' | translate }}
                </button>
                @if (listingService.isAllowedToArchive(document)) {
                  <button type="button" appDropdownItem (click)="folderClick.emit([document])"><i class="fa-regular fa-archive"></i> {{ 'button.archive' | translate }}</button>
                }
                @if (listingService.isAllowedToManage(document) && !appService.isEnterpriseChild) {
                  <button type="button" appDropdownItem (click)="transferClick.emit([document])"><i class="fa-regular fa-file-export"></i> {{ 'button.transfer' | translate }}</button>
                }
                @if (listingService.isAllowedToToggleBlock(document)) {
                  <button type="button" appDropdownItem (click)="toggleBlockClick.emit([document])">
                    <i class="fa-regular fa-{{ documentService.isPastDeadline(document) ? 'lock-open' : 'lock' }}"></i>
                    {{ 'button.' + (documentService.isPastDeadline(document) ? 'unblock' : 'block') | translate }}
                  </button>
                }
              }
            }
            @if (isTrash || documentsListingService.deletedByUserAt(document, currentUser.id)) {
              <button type="button" appDropdownItem (click)="restoreClick.emit([document])"><i class="fa-regular fa-undo"></i> {{ 'button.restore' | translate }}</button>
            }
            @if (listingService.isAllowedToResendWebhook(currentUser, document)) {
              <button type="button" appDropdownItem (click)="resendWebhookClick.emit(document)"><i class="fa-regular fa-webhook"></i> {{ 'button.webhookResend' | translate }}</button>
            }
            @if (!isTrash && !documentsListingService.deletedByUserAt(document, currentUser.id) && listingService.isAllowedToDelete(document)) {
              <hr class="dropdown-divider" />
              <button type="button" class="dropdown__item--danger" appDropdownItem (click)="deleteClick.emit([document])">
                <i class="fa-regular fa-trash"></i> {{ 'button.exclude' | translate }}
              </button>
            }
          </div>

          <div [id]="'table-submenu1-' + document.id" [appDropdownSubmenu]="'table-submenu1-' + document.id">
            <button type="button" appDropdownBackButton>{{ 'button.back' | translate }}</button>

            <a [href]="documentService.signedDocumentUrl(document)" [disabled]="!documentService.isSignedOnce(document)" target="_blank" appDropdownItem>
              <i [class]="document.qualified || hasMixedDocument([document]) ? 'fa-regular fa-print' : 'fa-regular fa-file-contract'"></i>
              {{ (document.qualified || hasMixedDocument([document]) ? 'documents.printPDF' : 'documents.signedPDF') | translate }}
            </a>

            @if (!document.qualified) {
              <a [href]="document.files?.certified" [disabled]="!documentService.isSignedOnce(document)" target="_blank" appDropdownItem>
                <i class="fa-regular fa-file-certificate"></i> {{ 'documents.sealedPDF' | translate }}
              </a>
            }

            @if (document.qualified || hasMixedDocument([document])) {
              <a [href]="documentService.padesDocumentUrl(document)" [disabled]="!documentService.isSignedOnce(document)" target="_blank" appDropdownItem>
                <i class="fa-regular fa-file-code"></i> {{ 'documents.padesFile' | translate }}
              </a>
            }

            <a href="javascript:void(0)" (click)="documentService.downloadFile(document)" [disabled]="!document.files?.original" appDropdownItem>
              <i class="fa-regular fa-file-alt"></i> {{ 'documents.originalFile' | translate }}
            </a>
          </div>
        </div>
      }
    </div>

    @if (currentUser && !hidePagination && !isLoading) {
      <button type="button" class="btn-M btn-text icon-start d-flex mt-3 mx-auto" (click)="loadPageClick.emit()">
        <i class="fas fa-rotate-reverse"></i>
        {{ 'button.loadMore' | translate }}
      </button>
    }
  </article>
}

<ng-template #sandboxTooltip>
  <div class="tooltip__title">{{ 'documents.sandboxDocument' | translate }}</div>
  <div class="tooltip__descr">{{ 'documents.sandboxDocumentDescr' | translate }}</div>
</ng-template>
